import React from 'react';
import { IAuditoriaBancariaResultado } from '../interfaces/IAuditoriaBancaria';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaBancariaResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Saldos Bancários não é um tributo — é uma auditoria complementar (saldo invertido em
// contas do Ativo). Por isso fica numa seção própria, abaixo do "Resumo por Tributo", em vez
// de uma linha dentro da tabela de tributos. Novos módulos de auditoria que não sejam tributo
// devem seguir o mesmo padrão: seção própria aqui, renderizada depois desta no AuditoriaPage.
const AuditoriaResumoBancario: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Saldos Bancários</h3>
      <p className='text-muted'>Auditoria complementar — não é um tributo. Clique para ver a análise detalhada por conta.</p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Disponibilidades Analisadas</th>
              <th className='text-end'>Penalidade Previsível</th>
              <th
                className='text-center'
                title='Dias com saldo credor no fechamento do período — contagem por dia (ocorrência), não por conta'
              >
                Dias ERRO
              </th>
              <th
                className='text-center'
                title='Dias com 1 a 5 dias consecutivos de saldo credor (AVISO) — contagem por dia (ocorrência), não por conta'
              >
                Dias AVISO
              </th>
              <th
                className='text-center'
                title='Dias com mais de 5 dias consecutivos de saldo credor (ALERTA) — contagem por dia (ocorrência), não por conta'
              >
                Dias ALERTA
              </th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('SALDOS_BANCARIOS')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Saldos Bancários</strong>
                  <span className={`auditoria-status status-${resultado.status}`} title={resultado.mensagemDirecionamento}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>
                    Depósitos bancários (1.01.01.02){resultado.possuiAplicacoesLiquidezImediata ? ' e aplicações de liquidez imediata (1.01.01.05)' : ''} com saldo invertido (credor)
                  </div>
                </div>
              </td>
              <td
                className='text-end'
                title={resultado.possuiAplicacoesLiquidezImediata
                  ? `Depósitos bancários: ${formatCurrency(resultado.totalDepositosBancarios)} + Aplicações de liquidez imediata: ${formatCurrency(resultado.totalAplicacoesLiquidezImediata)}`
                  : 'Soma dos saldos (em módulo) das contas de depósito bancário analisadas — nenhuma aplicação de liquidez imediata identificada na ECD'}
              >
                {formatCurrency(resultado.totalDisponibilidadesAnalisadas)}
              </td>
              <td className='text-end auditoria-col-highlight' title='Multa ECD potencial estimada — 5% sobre o saldo credor de fechamento desta conta, limitada a 1% da receita bruta do período'>
                {formatCurrency(resultado.penalidadePrevisivelTotal)}
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoBancario;
